import React, { useState,useEffect } from "react";
import { RxCross2 } from "react-icons/rx";
import { Link, useParams } from "react-router-dom";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import constants from "../../utils/constants";
import helpers from "../../utils/helpers";
import iconfromto from "../../assets/images/icon-fromto.png";

const ShowBetfair = () => {
  const [isLoader, setLoader] = useState(false);
  const [matchData, setMatchData] = useState([]);
  const params = useParams();

  const [search_params, setSearchParams] = useState({
    eventId: params.eventId,
    marketId: params.marketId,
   
  });
  const getMatchData = async () => {
    setLoader(true);

    const { status, data: response_users } = await apiGet(
      apiPath.riskBetfair+`?eventId=${params?.eventId}&marketId=${params?.marketId}`
    );
    if (status === 200) {
      if (response_users?.success) {
        if (response_users?.results) {
          setLoader(false);
       
          setMatchData(response_users?.results);
        }
      }
    }
  };
  useEffect(() => {
    getMatchData();
  }, []);
  useEffect(() => {
    const intervalID = setInterval(() => {
      getMatchData();
    
    }, 10 * 1000);
    return () => clearInterval(intervalID);
  }, [params?.eventId,params?.marketId ]);
  return (
    <div class="pop-wrap bg-white d-flex flex-column">
      <div class="w-100 pop-title h-14 pl-3 top-0 sticky d-flex justify-content-between align-items-center">
        <h2 class="xl-title flex-center space-x-2" id="title">
          Cricket
        </h2>
        <span
          onClick={() => window.close()}
          style={{ cursor: "pointer" }}
          className="d-flex align-items-center"
        >
          <RxCross2 size={23} color="white" />
          Close
        </span>
      </div>

      <div class="overflow-y-auto w-100 pop-wrap-inner px-3 pt-3">
        <div class="title-dark p-2 d-flex align-items-center space-x-1 ">
          {/* <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            ></path>
          </svg> */}
          <span id="marketTime" style={{ marginLeft: "5px" }}>
          {helpers.matchDateTimeNew( matchData?.createdAt)}{" "}
          </span>
        </div>

        <table class="mb-4 w-100 border-b">
          <thead class="title-lightdark">
            <tr>
              <th class="border-r" rowspan="2">
                Event name
              </th>
              <th class="border-r" rowspan="2">
                Selection name
              </th>
              <th class="border-r text-center bg-blue-300" colspan="2">
                Back
              </th>
              <th class="text-center bg-red-300" colspan="2">
                Lay
              </th>
            </tr>
            <tr>
              <th class="bg-blue-300 border-r">Avg. odds</th>
              <th class="bg-blue-300 border-r">Stake</th>
              <th class="bg-red-300 border-r">Avg. odds</th>
              <th class="bg-red-300 border-r">Stake</th>
            </tr>
          </thead>

          <tbody id="content">
          {Object.keys(matchData).length !== 0  && matchData?.jsonData.length>0 &&  matchData?.jsonData?.map((res,index) => {
           console.log("res?.averageOddsBack",res?.averageOddsBack)
            return(
            <tr id="tempTr" className="tempTr">
              <td class="align-L">
              {index<1 &&
                  <>
                <a
                  href="javascript:void(0);"
                  id="marketPath"
                  class="link-default"
                >
                 
                  <strong id="eventName"> {matchData?.eventName}</strong>
                  <img className="fromto" src={iconfromto}/>
                  <span id="marketName">Match Odds</span>
                </a>
                </>
                }
              </td>
              <td class="align-L" id="selectionName">
                {res?.RunnerName}
              </td>
              <td id="backAvgOdds"> {res?.averageOddsBack}</td>
              <td>
                <a
                  href="javascript:void(0);"
                  id="backStake"
                  class="link-default"
                >
                   {helpers?.currencyFormat(res?.averageBetAmountBack)}
                </a>
              </td>
              <td id="layAvgOdds" style={{ display: "table-cell" }}>
              {helpers?.currencyFormat(res?.averageOddsLay)}
              </td>
              <td style={{ display: "table-cell" }}>
                <a
                  href="javascript:void(0);"
                  class="text-red-600"
                  id="layStake"
                >
                    {helpers?.currencyFormat(res?.averageBetAmountLay)}
                </a>
              </td>
              
            </tr>)
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ShowBetfair;
